import { useEffect, useMemo, useState } from "react";

import { useRouter } from "next/router";

import LiveShowFullCard from "./LiveTv";

const ElectionLive = ({ electionLiveData = {}, firstActive = "" }) => {
  const router = useRouter();
  const [liveStreamData, setLiveStreamData] = useState(null);

  const liveKeys = useMemo(() => {
    if (!electionLiveData || typeof electionLiveData !== "object") {
      return [];
    }

    return Object.keys(electionLiveData).filter(
      (key) => electionLiveData?.[key]?.status === "1"
    );
  }, [electionLiveData]);

  const isBihar = router?.asPath?.includes("/elections/assembly-chunav/bihar");

  const tabs = useMemo(() => {
    const baseTabs = [...liveKeys];

    if (liveStreamData?.event_title) {
      baseTabs.push(liveStreamData.event_title);
    }

    if (baseTabs.length && isBihar) {
      return ["Bihar Tak", ...baseTabs.filter((tab) => tab !== "Bihar Tak")];
    }

    return baseTabs;
  }, [isBihar, liveKeys, liveStreamData?.event_title]);

  const defaultSelectedVideo = useMemo(() => {
    if (firstActive && tabs.includes(firstActive)) {
      return firstActive;
    }

    return tabs[0] || "";
  }, [firstActive, tabs]);

  const [selectedVideo, setSelectedVideo] = useState(defaultSelectedVideo);

  useEffect(() => {
    if (!tabs.length) {
      if (selectedVideo) {
        setSelectedVideo("");
      }
      return;
    }

    if (!selectedVideo || !tabs.includes(selectedVideo)) {
      setSelectedVideo(defaultSelectedVideo);
    }
  }, [defaultSelectedVideo, selectedVideo, tabs]);

  const activeTab = tabs.findIndex((tab) => tab === selectedVideo);
  const isLiveStreamTab = activeTab === tabs.length - 1 && !!liveStreamData?.live_stream_url;

  const vimeoId = process.env.NEXT_PUBLIC_LIVE_TV_VIMEO_ID || 4811929;

  useEffect(() => {
    const fetchLiveVideoData = async () => {
      const apiUrl =
        process.env.NEXT_PUBLIC_LIVE_TV_VIMEO_API + "/event_detail";

      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.NEXT_PUBLIC_LIVE_TV_VIMEO_TOKEN}`,
          },
          body: JSON.stringify({
            event_id: vimeoId,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch video details");
        }

        const data = await response.json();
        if (data?.data?.Event?.length > 0) {
          setLiveStreamData(data.data.Event[0]);
        }
      } catch (err) {
        console.error("Error fetching live video data:", err);
      }
    };

    fetchLiveVideoData();
  }, [vimeoId]);

  const path = (router?.asPath || "").split("?")[0];
  const isHomePage = path === "/" || path.startsWith("/madhya-pradesh");
  const isMp = router?.asPath?.includes("/madhya-pradesh/mptak-baithak");

  if (!isHomePage || isMp) {
    return null;
  }

  return (
    <div className="flex bg-white w-auto custom" style={{ position: "static" }}>
   {  <div className="flex flex-col w-full">
        <div className="flex flex-wrap items-stretch">
          {tabs.map((liveKey) => (
            <button
              key={liveKey}
              className={`px-2 py-1 text-sm font-semibold rounded-t-md border-2 transition-colors duration-300 ${
                liveKey === selectedVideo
                  ? "bg-primary text-white border-primary"
                  : "border-gray-200 hover:bg-gray-200"
              }`}
              onClick={() => {
                if (
                  liveKey === selectedVideo &&
                  electionLiveData?.[liveKey]?.link
                ) {
                  router.push(electionLiveData[liveKey].link);
                  return;
                }

                setSelectedVideo(liveKey);
              }}
            >
              {electionLiveData?.[liveKey]?.logo && (
                <img
                  width={32}
                  height={32}
                  src={electionLiveData[liveKey].logo}
                  className="w-8 h-8 mr-1 inline-block object-contain align-middle"
                  alt={`${liveKey} logo`}
                />
              )}
              {String(liveKey).charAt(0).toUpperCase() + String(liveKey).slice(1)}
            </button>
          ))}
        </div>

      { selectedVideo && electionLiveData?.[selectedVideo]?.livetv_code && <div className="w-full min-h-[191px]">
          {selectedVideo && electionLiveData?.[selectedVideo]?.livetv_code && (
            <div className="w-full overflow-hidden bg-black aspect-[16/9]">
              <iframe
                key={electionLiveData?.[selectedVideo]?.title}
                title={electionLiveData?.[selectedVideo]?.title}
                className="w-full h-full"
                allowFullScreen
                src={electionLiveData?.[selectedVideo]?.livetv_code}
                scrolling="no"
                frameBorder="0"
                allow="fullscreen; autoplay; encrypted-media; gyroscope"
                mozallowfullscreen="true"
                webkitallowfullscreen="true"
              />
            </div>
          )}

          {isLiveStreamTab && (
            <div className="title custom-iframe min-h-[191px] w-full md:w-3/4 lg:w-full">
              <div className="w-full overflow-hidden bg-black aspect-[16/9]">
                <LiveShowFullCard vimeoId={vimeoId} />
              </div>
            </div>
          )}
        </div>}
      </div>}
    </div>
  );
};

export default ElectionLive;
